import { State } from 'modules';

export const document = (state: State) => state.documents.items;
export const documentsLoaded = (state: State) => state.documents.documentsLoaded;